module.exports = __webpack_public_path__ + "static/media/number.fa1041b7.png";